const cName = 'gfh-autologin';
const cValue = 'disabled';

function isAutologinEnabled() {
  const isCookieAutologin = document.cookie
    .split('; ')
    .find((row) => row.startsWith(cName));

  return Boolean(isCookieAutologin);
}

function clearSessionData() {
  document.cookie = `${cName}=;expires=Thu, 01 Jan 1970`;
}

function disableAutologinSession() {
  document.cookie = `${cName}=${cValue}; SameSite=None; Secure`;
}

export default {
  isAutologinEnabled,
  clearSessionData,
  disableAutologinSession,
};
